<template>
<v-dialog v-model="isShown" width="500" >
    <v-card>
        <v-card-title class="primary-header pa-3" style="font-size: 25px">
            개발자 후원
        </v-card-title>
        <v-card-text class="pa-6">
            <sponsor-view />
        </v-card-text>
    </v-card>
</v-dialog>
</template>

<script>
import SponsorView from '@/views/components/SponsorView'

export default {
    name: 'sponsor-dialog',
    components: {
        SponsorView
    },
    data() {
        return {
            isShown: false
        }
    },
    computed: {
    },
    methods: {
        show() {
            this.isShown = true
        }
    }
}
</script>
